module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.6.2-255.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.6.2.md
// module id = 697
// module chunks = 260